import * as yup from 'yup';

export const buyersCreateStep2Schema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    contact: yup.object().shape({
      lastName: yup
        .string()
        .nullable()
        .max(255, t('buyers.create.errors.inputTooLong', { maxLength: '255' })),
      firstName: yup
        .string()
        .nullable()
        .max(255, t('buyers.create.errors.inputTooLong', { maxLength: '255' })),
      email: yup
        .string()
        .required(t('buyers.create.errors.missing.email'))
        .max(255, t('buyers.create.errors.inputTooLong', { maxLength: '255' }))
        .email(t('buyers.create.errors.invalidEmail')),
      phoneNumber: yup
        .string()
        .required(t('buyers.create.errors.missing.phoneNumber'))
        .max(12, t('buyers.create.errors.inputTooLong', { maxLength: '12' })),
    }),
  });
